import { useTranslation } from 'react-i18next';
import { formatPrice } from '@anytag/shared-utils';
import { TiktokAdAccountInfo, TiktokAdAccountStatus } from '@anytag/graphql';
import { TableCell } from '@anytag/shared-atoms';
import { Badge, BadgeProps } from '@anyui/core';
import { ColumnDef } from '@tanstack/react-table';

export const useAdvertiserAdAccountsTable = () => {
  const { t } = useTranslation();

  const getStatusColumnProps = (status: TiktokAdAccountStatus): BadgeProps => {
    switch (status) {
      case TiktokAdAccountStatus.VERIFIED:
        return { children: t('Option.Verified'), color: 'green' };
      case TiktokAdAccountStatus.UNVERIFIED:
        return { children: t('Option.Unverified'), color: 'red' };
      case TiktokAdAccountStatus.DISCONNECT:
        return { children: t('Option.Disconnected'), color: 'zinc' };
      default:
        return { children: null, color: 'zinc' };
    }
  };

  const columns: ColumnDef<TiktokAdAccountInfo>[] = [
    {
      accessorKey: 'name',
      header: t<string>('HeaderColumn.Ad Account Name'),
      cell: ({ row }) => <TableCell.Text value={row.original.name} />
    },
    {
      accessorKey: 'id',
      header: t<string>('HeaderColumn.Ad Account ID'),
      cell: ({ row }) => <TableCell.Text value={row.original.id} />
    },
    {
      accessorKey: 'status',
      header: t<string>('HeaderColumn.Status'),
      cell: ({ row }) => <Badge {...getStatusColumnProps(row.original.status)} />
    },
    {
      accessorKey: 'balanceAmount',
      header: t<string>('HeaderColumn.Balance'),
      cell: ({ row }) => (
        <TableCell.Text
          value={
            <span>
              {formatPrice(row.original.balanceAmount, null, 0)}&nbsp;{row.original.currencyId}
            </span>
          }
        />
      )
    }
  ];

  return { columns };
};
